function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { Rows } from "./rows";
import { Columns } from "./columns";
import { dataToTable } from "./table";
import { defaultConfig } from "./config";
import { isObject, isJson, createElement, flush, button, truncate } from "./helpers";
export var DataTable = /*#__PURE__*/function () {
  function DataTable(table) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DataTable);

    var dom = typeof table === "string" ? document.querySelector(table) : table; // user options

    this.options = _objectSpread(_objectSpread(_objectSpread({}, defaultConfig), options), {}, {
      layout: _objectSpread(_objectSpread({}, defaultConfig.layout), options.layout),
      labels: _objectSpread(_objectSpread({}, defaultConfig.labels), options.labels)
    });
    this.initialized = false;
    this.initialLayout = dom.innerHTML;
    this.initialSortable = this.options.sortable; // Disable manual sorting if no header is present (#4)

    if (!this.options.header) {
      this.options.sortable = false;
    }

    if (dom.tHead === null) {
      if (!this.options.data || this.options.data && !this.options.data.headings) {
        this.options.sortable = false;
      }
    }

    if (dom.tBodies.length && !dom.tBodies[0].rows.length) {
      if (this.options.data) {
        if (!this.options.data.data) {
          throw new Error("You seem to be using the data option, but you've not defined any rows.");
        }
      }
    }

    this.dom = dom;
    this.table = this.dom; // For compatibility. Remove in version 4

    this.listeners = {
      onResize: function onResize(event) {
        return _this.onResize(event);
      }
    };
    this.init();
  }
  /**
   * Add custom property or method to extend DataTable
   * @param  {String} prop    - Method name or property
   * @param  {Mixed} val      - Function or property value
   * @return {Void}
   */


  _createClass(DataTable, [{
    key: "init",
    value:
    /**
     * Initialize the instance
     * @param  {Object} options
     * @return {Void}
     */
    function init(options) {
      var _this2 = this;

      if (this.initialized || this.dom.classList.contains("dataTable-table")) {
        return false;
      }

      Object.assign(this.options, options || {});
      this.currentPage = 1;
      this.onFirstPage = true;
      this.hiddenColumns = [];
      this.columnRenderers = [];
      this.selectedColumns = [];
      this.render();
      setTimeout(function () {
        _this2.emit("datatable.init");

        _this2.initialized = true;

        if (_this2.options.plugins) {
          Object.entries(_this2.options.plugins).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                plugin = _ref2[0],
                options = _ref2[1];

            if (_this2[plugin] && typeof _this2[plugin] === "function") {
              _this2[plugin] = _this2[plugin](options, {
                createElement: createElement
              }); // Init plugin

              if (options.enabled && _this2[plugin].init && typeof _this2[plugin].init === "function") {
                _this2[plugin].init();
              }
            }
          });
        }
      }, 10);
    }
    /**
     * Render the instance
     * @param  {String} type
     * @return {Void}
     */

  }, {
    key: "render",
    value: function render(type) {
      if (type) {
        switch (type) {
          case "page":
            this.renderPage();
            break;

          case "pager":
            this.renderPager();
            break;

          case "header":
            this.renderHeader();
            break;
        }

        return false;
      }

      var options = this.options;
      var template = ""; // Convert data to HTML

      if (options.data) {
        dataToTable.call(this);
      } // Store references


      this.body = this.dom.tBodies[0];
      this.head = this.dom.tHead;
      this.foot = this.dom.tFoot;

      if (!this.body) {
        this.body = createElement("tbody");
        this.dom.appendChild(this.body);
      }

      this.hasRows = this.body.rows.length > 0; // Make a tHead if there isn't one (fixes #8)

      if (!this.head) {
        var h = createElement("thead");
        var t = createElement("tr");

        if (this.hasRows) {
          Array.from(this.body.rows[0].cells).forEach(function () {
            t.appendChild(createElement("th"));
          });
          h.appendChild(t);
        }

        this.head = h;
        this.dom.insertBefore(this.head, this.body);
        this.hiddenHeader = options.hiddenHeader;
      }

      this.headings = [];
      this.hasHeadings = this.head.rows.length > 0;

      if (this.hasHeadings) {
        this.header = this.head.rows[0];
        this.headings = [].slice.call(this.header.cells);
      } // Header


      if (!options.header) {
        if (this.head) {
          this.dom.removeChild(this.dom.tHead);
        }
      } // Footer


      if (options.footer) {
        if (this.head && !this.foot) {
          this.foot = createElement("tfoot", {
            html: this.head.innerHTML
          });
          this.dom.appendChild(this.foot);
        }
      } else {
        if (this.foot) {
          this.dom.removeChild(this.dom.tFoot);
        }
      } // Build


      this.wrapper = createElement("div", {
        class: "dataTable-wrapper dataTable-loading"
      }); // Template for custom layouts

      template += "<div class='dataTable-top'>";
      template += options.layout.top;
      template += "</div>";

      if (options.scrollY.length) {
        template += "<div class='dataTable-container' style='height: ".concat(options.scrollY, "; overflow-Y: auto;'></div>");
      } else {
        template += "<div class='dataTable-container'></div>";
      }

      template += "<div class='dataTable-bottom'>";
      template += options.layout.bottom;
      template += "</div>"; // Info placement

      template = template.replace("{info}", options.paging ? "<div class='dataTable-info'></div>" : ""); // Per Page Select

      if (options.paging && options.perPageSelect) {
        var wrap = "<div class='dataTable-dropdown'><label>";
        wrap += options.labels.perPage;
        wrap += "</label></div>"; // Create the select

        var select = createElement("select", {
          class: "dataTable-selector"
        }); // Create the options

        options.perPageSelect.forEach(function (val) {
          var selected = val === options.perPage;
          var option = new Option(val, val, selected, selected);
          select.add(option);
        }); // Custom label

        wrap = wrap.replace("{select}", select.outerHTML); // Selector placement

        template = template.replace("{select}", wrap);
      } else {
        template = template.replace("{select}", "");
      } // Searchable


      if (options.searchable) {
        var form = "<div class='dataTable-search'><input class='dataTable-input' placeholder='".concat(options.labels.placeholder, "' type='text'></div>"); // Search input placement

        template = template.replace("{search}", form);
      } else {
        template = template.replace("{search}", "");
      }

      if (this.hasHeadings) {
        // Sortable
        this.render("header");
      } // Add table class


      this.dom.classList.add("dataTable-table"); // Paginator

      var paginatorWrapper = createElement("nav", {
        class: "dataTable-pagination"
      });
      var paginator = createElement("ul", {
        class: "dataTable-pagination-list"
      });
      paginatorWrapper.appendChild(paginator); // Pager(s) placement

      template = template.replace(/\{pager\}/g, paginatorWrapper.outerHTML);
      this.wrapper.innerHTML = template;
      this.container = this.wrapper.querySelector(".dataTable-container");
      this.pagers = this.wrapper.querySelectorAll(".dataTable-pagination-list");
      this.label = this.wrapper.querySelector(".dataTable-info"); // Insert in to DOM tree

      this.dom.parentNode.replaceChild(this.wrapper, this.dom);
      this.container.appendChild(this.dom); // Store the table dimensions

      this.rect = this.dom.getBoundingClientRect(); // Convert rows to array for processing

      this.data = Array.from(this.body.rows);
      this.activeRows = this.data.slice();
      this.activeHeadings = this.headings.slice(); // Update

      this.update();
      this.setColumns(); // Fix height

      this.fixHeight(); // Fix columns

      this.fixColumns(); // Class names

      if (!options.header) {
        this.wrapper.classList.add("no-header");
      }

      if (!options.footer) {
        this.wrapper.classList.add("no-footer");
      }

      if (options.sortable) {
        this.wrapper.classList.add("sortable");
      }

      if (options.searchable) {
        this.wrapper.classList.add("searchable");
      }

      if (options.fixedHeight) {
        this.wrapper.classList.add("fixed-height");
      }

      if (options.fixedColumns) {
        this.wrapper.classList.add("fixed-columns");
      }

      this.bindEvents();
    }
    /**
     * Render the page
     * @return {Void}
     */

  }, {
    key: "renderPage",
    value: function renderPage() {
      var _this3 = this;

      if (this.hasHeadings) {
        flush(this.header);
        this.activeHeadings.forEach(function (th) {
          return _this3.header.appendChild(th);
        });
      }

      if (this.hasRows && this.totalPages) {
        if (this.currentPage > this.totalPages) {
          this.currentPage = 1;
        } // Use a fragment to limit touching the DOM


        var index = this.currentPage - 1;
        var frag = document.createDocumentFragment();
        this.pages[index].forEach(function (row) {
          return frag.appendChild(_this3.rows().render(row));
        });
        this.clear(frag);
        this.onFirstPage = this.currentPage === 1;
        this.onLastPage = this.currentPage === this.lastPage;
      } else {
        this.setMessage(this.options.labels.noRows);
      } // Update the info


      var current = 0;
      var f = 0;
      var t = 0;
      var items;

      if (this.totalPages) {
        current = this.currentPage - 1;
        f = current * this.options.perPage;
        t = f + this.pages[current].length;
        f = f + 1;
        items = this.searching ? this.searchData.length : this.data.length;
      }

      if (this.label && this.options.labels.info.length) {
        // CUSTOM LABELS
        var string = this.options.labels.info.replace("{start}", f).replace("{end}", t).replace("{page}", this.currentPage).replace("{pages}", this.totalPages).replace("{rows}", items);
        this.label.innerHTML = items ? string : "";
      }

      if (this.currentPage == 1) {
        this.fixHeight();
      }
    }
    /**
     * Render the pager(s)
     * @return {Void}
     */

  }, {
    key: "renderPager",
    value: function renderPager() {
      flush(this.pagers);

      if (this.totalPages > 1) {
        var c = "pager";
        var frag = document.createDocumentFragment();
        var prev = this.onFirstPage ? 1 : this.currentPage - 1;
        var next = this.onLastPage ? this.totalPages : this.currentPage + 1; // first button

        if (this.options.firstLast) {
          frag.appendChild(button(c, 1, this.options.firstText));
        } // prev button


        if (this.options.nextPrev && !this.onFirstPage) {
          frag.appendChild(button(c, prev, this.options.prevText));
        }

        var pager = this.links; // truncate the links

        if (this.options.truncatePager) {
          pager = truncate(this.links, this.currentPage, this.pages.length, this.options.pagerDelta, this.options.ellipsisText);
        } // active page link


        this.links[this.currentPage - 1].classList.add("active"); // append the links

        pager.forEach(function (p) {
          p.classList.remove("active");
          frag.appendChild(p);
        });
        this.links[this.currentPage - 1].classList.add("active"); // next button

        if (this.options.nextPrev && !this.onLastPage) {
          frag.appendChild(button(c, next, this.options.nextText));
        } // first button


        if (this.options.firstLast) {
          frag.appendChild(button(c, this.totalPages, this.options.lastText));
        } // We may have more than one pager


        this.pagers.forEach(function (pager) {
          pager.appendChild(frag.cloneNode(true));
        });
      }
    }
    /**
     * Render the header
     * @return {Void}
     */

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this4 = this;

      this.labels = [];

      if (this.headings && this.headings.length) {
        this.headings.forEach(function (th, i) {
          _this4.labels[i] = th.textContent;

          if (th.firstElementChild && th.firstElementChild.classList.contains("dataTable-sorter")) {
            th.innerHTML = th.firstElementChild.innerHTML;
          }

          th.sortable = th.getAttribute("data-sortable") !== "false";
          th.originalCellIndex = i;

          if (_this4.options.sortable && th.sortable) {
            var link = createElement("a", {
              href: "#",
              class: "dataTable-sorter",
              html: th.innerHTML
            });
            th.innerHTML = "";
            th.setAttribute("data-sortable", "");
            th.appendChild(link);
          }
        });
      }

      this.fixColumns();
    }
    /**
     * Bind event listeners
     * @return {[type]} [description]
     */

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this5 = this;

      var options = this.options; // Per page selector

      if (options.perPageSelect) {
        var selector = this.wrapper.querySelector(".dataTable-selector");

        if (selector) {
          // Change per page
          selector.addEventListener("change", function () {
            options.perPage = parseInt(selector.value, 10);

            _this5.update();

            _this5.fixHeight();

            _this5.emit("datatable.perpage", options.perPage);
          }, false);
        }
      } // Search input


      if (options.searchable) {
        this.input = this.wrapper.querySelector(".dataTable-input");

        if (this.input) {
          this.input.addEventListener("keyup", function () {
            return _this5.search(_this5.input.value);
          }, false);
        }
      } // Pager(s) / sorting


      this.wrapper.addEventListener("click", function (e) {
        var t = e.target.closest("a");

        if (t && t.nodeName.toLowerCase() === "a") {
          if (t.hasAttribute("data-page")) {
            _this5.page(t.getAttribute("data-page"));

            e.preventDefault();
          } else if (options.sortable && t.classList.contains("dataTable-sorter") && t.parentNode.getAttribute("data-sortable") != "false") {
            _this5.columns().sort(_this5.headings.indexOf(t.parentNode));

            e.preventDefault();
          }
        }
      }, false);
      window.addEventListener("resize", this.listeners.onResize);
    }
    /**
     * execute on resize
     */

  }, {
    key: "onResize",
    value: function onResize() {
      this.rect = this.container.getBoundingClientRect();

      if (!this.rect.width) {
        // No longer shown, likely no longer part of DOM. Give up.
        return;
      }

      this.fixColumns();
    }
    /**
     * Set up columns
     * @return {[type]} [description]
     */

  }, {
    key: "setColumns",
    value: function setColumns(ajax) {
      var _this6 = this;

      if (!ajax) {
        this.data.forEach(function (row) {
          Array.from(row.cells).forEach(function (cell) {
            cell.data = cell.innerHTML;
          });
        });
      } // Check for the columns option


      if (this.options.columns && this.headings.length) {
        this.options.columns.forEach(function (data) {
          // convert single column selection to array
          if (!Array.isArray(data.select)) {
            data.select = [data.select];
          }

          if (data.hasOwnProperty("render") && typeof data.render === "function") {
            _this6.selectedColumns = _this6.selectedColumns.concat(data.select);

            _this6.columnRenderers.push({
              columns: data.select,
              renderer: data.render
            });
          } // Add the data attributes to the th elements


          data.select.forEach(function (column) {
            var th = _this6.headings[column];

            if (!th) {
              return;
            }

            if (data.type) {
              th.setAttribute("data-type", data.type);
            }

            if (data.format) {
              th.setAttribute("data-format", data.format);
            }

            if (data.hasOwnProperty("sortable")) {
              th.setAttribute("data-sortable", data.sortable);
            }

            if (data.hasOwnProperty("hidden")) {
              if (data.hidden !== false) {
                _this6.columns().hide([column]);
              }
            }

            if (data.hasOwnProperty("sort") && data.select.length === 1) {
              _this6.columns().sort(data.select[0], data.sort, true);
            }
          });
        });
      }

      if (this.hasRows) {
        this.data.forEach(function (row, i) {
          row.dataIndex = i;
          Array.from(row.cells).forEach(function (cell) {
            cell.data = cell.innerHTML;
          });
        });

        if (this.selectedColumns.length) {
          this.data.forEach(function (row) {
            Array.from(row.cells).forEach(function (cell, i) {
              if (_this6.selectedColumns.includes(i)) {
                _this6.columnRenderers.forEach(function (options) {
                  if (options.columns.includes(i)) {
                    cell.innerHTML = options.renderer.call(_this6, cell.data, cell, row);
                  }
                });
              }
            });
          });
        }

        this.columns().rebuild();
      }

      this.render("header");
    }
    /**
     * Destroy the instance
     * @return {void}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.dom.innerHTML = this.initialLayout; // Remove the className

      this.dom.classList.remove("dataTable-table"); // Remove the containers

      this.wrapper.parentNode.replaceChild(this.dom, this.wrapper);
      this.initialized = false;
      window.removeEventListener("resize", this.listeners.onResize);
    }
    /**
     * Update the instance
     * @return {Void}
     */

  }, {
    key: "update",
    value: function update() {
      this.wrapper.classList.remove("dataTable-empty");
      this.paginate(this);
      this.render("page");
      this.links = [];
      var i = this.pages.length;

      while (i--) {
        var num = i + 1;
        this.links[i] = button(i === 0 ? "active" : "", num, num);
      }

      this.sorting = false;
      this.render("pager");
      this.rows().update();
      this.emit("datatable.update");
    }
    /**
     * Sort rows into pages
     * @return {Number}
     */

  }, {
    key: "paginate",
    value: function paginate() {
      var _this7 = this;

      var perPage = this.options.perPage;
      var rows = this.activeRows;

      if (this.searching) {
        rows = [];
        this.searchData.forEach(function (index) {
          return rows.push(_this7.activeRows[index]);
        });
      }

      if (this.options.paging) {
        // Check for hidden columns
        this.pages = rows.map(function (tr, i) {
          return i % perPage === 0 ? rows.slice(i, i + perPage) : null;
        }).filter(function (page) {
          return page;
        });
      } else {
        this.pages = [rows];
      }

      this.totalPages = this.lastPage = this.pages.length;
      return this.totalPages;
    }
    /**
     * Fix column widths
     * @return {Void}
     */

  }, {
    key: "fixColumns",
    value: function fixColumns() {
      var _this8 = this;

      if ((this.options.scrollY.length || this.options.fixedColumns) && this.activeHeadings && this.activeHeadings.length) {
        var cells;
        var hd = false;
        this.columnWidths = []; // If we have headings we need only set the widths on them
        // otherwise we need a temp header and the widths need applying to all cells

        if (this.dom.tHead) {
          if (this.options.scrollY.length) {
            hd = createElement("thead");
            hd.appendChild(createElement("tr"));
            hd.style.height = "0px";

            if (this.headerTable) {
              // move real header back into place
              this.dom.tHead = this.headerTable.tHead;
            }
          } // Reset widths


          this.activeHeadings.forEach(function (cell) {
            cell.style.width = "";
          });
          var totalOffsetWidth = this.activeHeadings.reduce(function (total, cell) {
            return total + cell.offsetWidth;
          }, 0);
          this.activeHeadings.forEach(function (cell, i) {
            var ow = cell.offsetWidth;
            var w = ow / totalOffsetWidth * 100;
            cell.style.width = "".concat(w, "%");
            _this8.columnWidths[i] = ow;

            if (_this8.options.scrollY.length) {
              var th = createElement("th");
              hd.firstElementChild.appendChild(th);
              th.style.width = "".concat(w, "%");
              th.style.paddingTop = "0";
              th.style.paddingBottom = "0";
              th.style.border = "0";
            }
          });

          if (this.options.scrollY.length) {
            var container = this.dom.parentElement;

            if (!this.headerTable) {
              this.headerTable = createElement("table", {
                class: "dataTable-table"
              });
              var headercontainer = createElement("div", {
                class: "dataTable-headercontainer"
              });
              headercontainer.appendChild(this.headerTable);
              container.parentElement.insertBefore(headercontainer, container);
            }

            var thd = this.dom.tHead;
            this.dom.replaceChild(hd, thd);
            this.headerTable.tHead = thd; // Compensate for scrollbars.

            this.headerTable.parentElement.style.paddingRight = "".concat(this.headerTable.clientWidth - this.dom.clientWidth + parseInt(this.headerTable.parentElement.style.paddingRight || "0", 10), "px");

            if (container.scrollHeight > container.clientHeight) {
              // scrollbars on one page means scrollbars on all pages.
              container.style.overflowY = "scroll";
            }
          }
        } else {
          cells = []; // Make temperary headings

          hd = createElement("thead");
          var r = createElement("tr");
          Array.from(this.dom.tBodies[0].rows[0].cells).forEach(function () {
            var th = createElement("th");
            r.appendChild(th);
            cells.push(th);
          });
          hd.appendChild(r);
          this.dom.insertBefore(hd, this.body);
          var widths = [];
          cells.forEach(function (cell, i) {
            var ow = cell.offsetWidth;
            var w = ow / _this8.rect.width * 100;
            widths.push(w);
            _this8.columnWidths[i] = ow;
          });
          this.data.forEach(function (row) {
            Array.from(row.cells).forEach(function (cell, i) {
              if (_this8.columns(cell.cellIndex).visible()) cell.style.width = "".concat(widths[i], "%");
            });
          }); // Discard the temp header

          this.dom.removeChild(hd);
        }
      }
    }
    /**
     * Fix the container height
     * @return {Void}
     */

  }, {
    key: "fixHeight",
    value: function fixHeight() {
      if (this.options.fixedHeight) {
        this.container.style.height = null;
        this.rect = this.container.getBoundingClientRect();
        this.container.style.height = "".concat(this.rect.height, "px");
      }
    }
    /**
     * Perform a search of the data set
     * @param  {string} query
     * @return {void}
     */

  }, {
    key: "search",
    value: function search(query) {
      var _this9 = this;

      if (!this.hasRows) return false;
      query = query.toLowerCase();
      this.currentPage = 1;
      this.searching = true;
      this.searchData = [];

      if (!query.length) {
        this.searching = false;
        this.update();
        this.emit("datatable.search", query, this.searchData);
        this.wrapper.classList.remove("search-results");
        return false;
      }

      this.clear();
      this.data.forEach(function (row, idx) {
        var inArray = _this9.searchData.includes(row); // https://github.com/Mobius1/Vanilla-DataTables/issues/12


        var doesQueryMatch = query.split(" ").reduce(function (bool, word) {
          var includes = false;
          var cell = null;
          var content = null;

          for (var x = 0; x < row.cells.length; x++) {
            cell = row.cells[x];
            content = cell.hasAttribute("data-content") ? cell.getAttribute("data-content") : cell.textContent;

            if (content.toLowerCase().includes(word) && _this9.columns(cell.cellIndex).visible()) {
              includes = true;
              break;
            }
          }

          return bool && includes;
        }, true);

        if (doesQueryMatch && !inArray) {
          row.searchIndex = idx;

          _this9.searchData.push(idx);
        } else {
          row.searchIndex = null;
        }
      });
      this.wrapper.classList.add("search-results");

      if (!this.searchData.length) {
        this.wrapper.classList.remove("search-results");
        this.setMessage(this.options.labels.noResults);
      } else {
        this.update();
      }

      this.emit("datatable.search", query, this.searchData);
    }
    /**
     * Change page
     * @param  {int} page
     * @return {void}
     */

  }, {
    key: "page",
    value: function page(_page) {
      // We don't want to load the current page again.
      if (_page == this.currentPage) {
        return false;
      }

      if (!isNaN(_page)) {
        this.currentPage = parseInt(_page, 10);
      }

      if (_page > this.pages.length || _page < 0) {
        return false;
      }

      this.render("page");
      this.render("pager");
      this.emit("datatable.page", _page);
    }
    /**
     * Sort by column
     * @param  {int} column - The column no.
     * @param  {string} direction - asc or desc
     * @return {void}
     */

  }, {
    key: "sortColumn",
    value: function sortColumn(column, direction) {
      // Use columns API until sortColumn method is removed
      this.columns().sort(column, direction);
    }
    /**
     * Add new row data
     * @param {object} data
     */

  }, {
    key: "insert",
    value: function insert(data) {
      var _this10 = this;

      var rows = [];

      if (isObject(data)) {
        if (data.headings) {
          if (!this.hasHeadings && !this.hasRows) {
            var tr = createElement("tr");
            data.headings.forEach(function (heading) {
              var th = createElement("th", {
                html: heading
              });
              tr.appendChild(th);
            });
            this.head.appendChild(tr);
            this.header = tr;
            this.headings = [].slice.call(tr.cells);
            this.hasHeadings = true; // Re-enable sorting if it was disabled due
            // to missing header

            this.options.sortable = this.initialSortable; // Allow sorting on new header

            this.render("header"); // Activate newly added headings

            this.activeHeadings = this.headings.slice();
          }
        }

        if (data.data && Array.isArray(data.data)) {
          rows = data.data;
        }
      } else if (Array.isArray(data)) {
        data.forEach(function (row) {
          var r = [];
          Object.entries(row).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                heading = _ref4[0],
                cell = _ref4[1];

            var index = _this10.labels.indexOf(heading);

            if (index > -1) {
              r[index] = cell;
            }
          });
          rows.push(r);
        });
      }

      if (rows.length) {
        this.rows().add(rows);
        this.hasRows = true;
      }

      this.update();
      this.setColumns();
      this.fixColumns();
    }
    /**
     * Refresh the instance
     * @return {void}
     */

  }, {
    key: "refresh",
    value: function refresh() {
      if (this.options.searchable) {
        this.input.value = "";
        this.searching = false;
      }

      this.currentPage = 1;
      this.onFirstPage = true;
      this.update();
      this.emit("datatable.refresh");
    }
    /**
     * Truncate the table
     * @param  {mixes} html - HTML string or HTMLElement
     * @return {void}
     */

  }, {
    key: "clear",
    value: function clear(html) {
      if (this.body) {
        flush(this.body);
      }

      var parent = this.body;

      if (!this.body) {
        parent = this.dom;
      }

      if (html) {
        if (typeof html === "string") {
          var frag = document.createDocumentFragment();
          frag.innerHTML = html;
        }

        parent.appendChild(html);
      }
    }
    /**
     * Export table to various formats (csv, txt or sql)
     * @param  {Object} userOptions User options
     * @return {Boolean}
     */

  }, {
    key: "export",
    value: function _export(userOptions) {
      if (!this.hasHeadings && !this.hasRows) return false;
      var headers = this.activeHeadings;
      var rows = [];
      var arr = [];
      var i;
      var x;
      var str;
      var link;
      var defaults = {
        download: true,
        skipColumn: [],
        // csv
        lineDelimiter: "\n",
        columnDelimiter: ",",
        // sql
        tableName: "myTable",
        // json
        replacer: null,
        space: 4
      }; // Check for the options object

      if (!isObject(userOptions)) {
        return false;
      }

      var options = _objectSpread(_objectSpread({}, defaults), userOptions);

      if (options.type) {
        if (options.type === "txt" || options.type === "csv") {
          // Include headings
          rows[0] = this.header;
        } // Selection or whole table


        if (options.selection) {
          // Page number
          if (!isNaN(options.selection)) {
            rows = rows.concat(this.pages[options.selection - 1]);
          } else if (Array.isArray(options.selection)) {
            // Array of page numbers
            for (i = 0; i < options.selection.length; i++) {
              rows = rows.concat(this.pages[options.selection[i] - 1]);
            }
          }
        } else {
          rows = rows.concat(this.activeRows);
        } // Only proceed if we have data


        if (rows.length) {
          if (options.type === "txt" || options.type === "csv") {
            str = "";

            for (i = 0; i < rows.length; i++) {
              for (x = 0; x < rows[i].cells.length; x++) {
                // Check for column skip and visibility
                if (!options.skipColumn.includes(headers[x].originalCellIndex) && this.columns(headers[x].originalCellIndex).visible()) {
                  var text = rows[i].cells[x].textContent;
                  text = text.trim();
                  text = text.replace(/\s{2,}/g, " ");
                  text = text.replace(/\n/g, "  ");
                  text = text.replace(/"/g, "\"\""); //have to manually encode "#" as encodeURI leaves it as is.

                  text = text.replace(/#/g, "%23");
                  if (text.includes(",")) text = "\"".concat(text, "\"");
                  str += text + options.columnDelimiter;
                }
              } // Remove trailing column delimiter


              str = str.trim().substring(0, str.length - 1); // Apply line delimiter

              str += options.lineDelimiter;
            } // Remove trailing line delimiter


            str = str.trim().substring(0, str.length - 1);

            if (options.download) {
              str = "data:text/csv;charset=utf-8,".concat(str);
            }
          } else if (options.type === "sql") {
            // Begin INSERT statement
            str = "INSERT INTO `".concat(options.tableName, "` ("); // Convert table headings to column names

            for (i = 0; i < headers.length; i++) {
              // Check for column skip and column visibility
              if (!options.skipColumn.includes(headers[i].originalCellIndex) && this.columns(headers[i].originalCellIndex).visible()) {
                str += "`".concat(headers[i].textContent, "`,");
              }
            } // Remove trailing comma


            str = str.trim().substring(0, str.length - 1); // Begin VALUES

            str += ") VALUES "; // Iterate rows and convert cell data to column values

            for (i = 0; i < rows.length; i++) {
              str += "(";

              for (x = 0; x < rows[i].cells.length; x++) {
                // Check for column skip and column visibility
                if (!options.skipColumn.includes(headers[x].originalCellIndex) && this.columns(headers[x].originalCellIndex).visible()) {
                  str += "\"".concat(rows[i].cells[x].textContent, "\",");
                }
              } // Remove trailing comma


              str = str.trim().substring(0, str.length - 1); // end VALUES

              str += "),";
            } // Remove trailing comma


            str = str.trim().substring(0, str.length - 1); // Add trailing colon

            str += ";";

            if (options.download) {
              str = "data:application/sql;charset=utf-8,".concat(str);
            }
          } else if (options.type === "json") {
            // Iterate rows
            for (x = 0; x < rows.length; x++) {
              arr[x] = arr[x] || {}; // Iterate columns

              for (i = 0; i < headers.length; i++) {
                // Check for column skip and column visibility
                if (!options.skipColumn.includes(headers[i].originalCellIndex) && this.columns(headers[i].originalCellIndex).visible()) {
                  arr[x][headers[i].textContent] = rows[x].cells[i].textContent;
                }
              }
            } // Convert the array of objects to JSON string


            str = JSON.stringify(arr, options.replacer, options.space);

            if (options.download) {
              str = "data:application/json;charset=utf-8,".concat(str);
            }
          } // Download


          if (options.download) {
            // Filename
            options.filename = options.filename || "datatable_export";
            options.filename += ".".concat(options.type);
            str = encodeURI(str); // Create a link to trigger the download

            link = document.createElement("a");
            link.href = str;
            link.download = options.filename; // Append the link

            document.body.appendChild(link); // Trigger the download

            link.click(); // Remove the link

            document.body.removeChild(link);
          }

          return str;
        }
      }

      return false;
    }
    /**
     * Import data to the table
     * @param  {Object} userOptions User options
     * @return {Boolean}
     */

  }, {
    key: "import",
    value: function _import(userOptions) {
      var obj = false;
      var defaults = {
        // csv
        lineDelimiter: "\n",
        columnDelimiter: ",",
        removeDoubleQuotes: false
      }; // Check for the options object

      if (!isObject(userOptions)) {
        return false;
      }

      var options = _objectSpread(_objectSpread({}, defaults), userOptions);

      if (options.data.length || isObject(options.data)) {
        // Import CSV
        if (options.type === "csv") {
          obj = {
            data: []
          }; // Split the string into rows

          var rows = options.data.split(options.lineDelimiter);

          if (rows.length) {
            if (options.headings) {
              obj.headings = rows[0].split(options.columnDelimiter);

              if (options.removeDoubleQuotes) {
                obj.headings = obj.headings.map(function (e) {
                  return e.trim().replace(/(^"|"$)/g, "");
                });
              }

              rows.shift();
            }

            rows.forEach(function (row, i) {
              obj.data[i] = []; // Split the rows into values

              var values = row.split(options.columnDelimiter);

              if (values.length) {
                values.forEach(function (value) {
                  if (options.removeDoubleQuotes) {
                    value = value.trim().replace(/(^"|"$)/g, "");
                  }

                  obj.data[i].push(value);
                });
              }
            });
          }
        } else if (options.type === "json") {
          var json = isJson(options.data); // Valid JSON string

          if (json) {
            obj = {
              headings: [],
              data: []
            };
            json.forEach(function (data, i) {
              obj.data[i] = [];
              Object.entries(data).forEach(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2),
                    column = _ref6[0],
                    value = _ref6[1];

                if (!obj.headings.includes(column)) {
                  obj.headings.push(column);
                }

                obj.data[i].push(value);
              });
            });
          } else {// console.warn("That's not valid JSON!")
          }
        }

        if (isObject(options.data)) {
          obj = options.data;
        }

        if (obj) {
          // Add the rows
          this.insert(obj);
        }
      }

      return false;
    }
    /**
     * Print the table
     * @return {void}
     */

  }, {
    key: "print",
    value: function print() {
      var headings = this.activeHeadings;
      var rows = this.activeRows;
      var table = createElement("table");
      var thead = createElement("thead");
      var tbody = createElement("tbody");
      var tr = createElement("tr");
      headings.forEach(function (th) {
        tr.appendChild(createElement("th", {
          html: th.textContent
        }));
      });
      thead.appendChild(tr);
      rows.forEach(function (row) {
        var tr = createElement("tr");
        Array.from(row.cells).forEach(function (cell) {
          tr.appendChild(createElement("td", {
            html: cell.textContent
          }));
        });
        tbody.appendChild(tr);
      });
      table.appendChild(thead);
      table.appendChild(tbody); // Open new window

      var w = window.open(); // Append the table to the body

      w.document.body.appendChild(table); // Print

      w.print();
    }
    /**
     * Show a message in the table
     * @param {string} message
     */

  }, {
    key: "setMessage",
    value: function setMessage(message) {
      var colspan = 1;

      if (this.hasRows) {
        colspan = this.data[0].cells.length;
      } else if (this.activeHeadings.length) {
        colspan = this.activeHeadings.length;
      }

      this.wrapper.classList.add("dataTable-empty");

      if (this.label) {
        this.label.innerHTML = "";
      }

      this.totalPages = 0;
      this.render("pager");
      this.clear(createElement("tr", {
        html: "<td class=\"dataTables-empty\" colspan=\"".concat(colspan, "\">").concat(message, "</td>")
      }));
    }
    /**
     * Columns API access
     * @return {Object} new Columns instance
     */

  }, {
    key: "columns",
    value: function columns(_columns) {
      return new Columns(this, _columns);
    }
    /**
     * Rows API access
     * @return {Object} new Rows instance
     */

  }, {
    key: "rows",
    value: function rows(_rows) {
      return new Rows(this, _rows);
    }
    /**
     * Add custom event listener
     * @param  {String} event
     * @param  {Function} callback
     * @return {Void}
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      this.events = this.events || {};
      this.events[event] = this.events[event] || [];
      this.events[event].push(callback);
    }
    /**
     * Remove custom event listener
     * @param  {String} event
     * @param  {Function} callback
     * @return {Void}
     */

  }, {
    key: "off",
    value: function off(event, callback) {
      this.events = this.events || {};
      if (event in this.events === false) return;
      this.events[event].splice(this.events[event].indexOf(callback), 1);
    }
    /**
     * Fire custom event
     * @param  {String} event
     * @return {Void}
     */

  }, {
    key: "emit",
    value: function emit(event) {
      this.events = this.events || {};
      if (event in this.events === false) return;

      for (var i = 0; i < this.events[event].length; i++) {
        this.events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
      }
    }
  }], [{
    key: "extend",
    value: function extend(prop, val) {
      if (typeof val === "function") {
        DataTable.prototype[prop] = val;
      } else {
        DataTable[prop] = val;
      }
    }
  }]);

  return DataTable;
}();